import React from 'react';
import { Button, ModalBody } from 'reactstrap';

import InstructorReply from './InstructorReply/InstructorReply';
import YourAnswer from './YourAnswer/YourAnswer';
import { downloadFile } from '../../../../../../../helpers';
import { useUnit } from '../../../../../../../hooks/units';
import styles from '../../../../../../../styles/Unit.module.scss';

const Failed = () => {
  const handleShowReply = () => {
    document.getElementById('btnReply')?.click();
  };
  const unitSelected = useUnit();
  const assignment = unitSelected?.assignment;
  const file = assignment?.file;
  return (
    <div className="text-center">
      <Button.Ripple
        className="round"
        color="secondary"
        onClick={handleShowReply}
      >
        You didn't pass. Your instructor has left a reply.
      </Button.Ripple>
      <div className="mt-2 d-flex justify-content-center">
        <div className="text-left">
          <div>
            <strong>Instructor reply</strong>
          </div>
          <hr className="my-05" />
          <p className="mb-0-important pb-05">
            Grade:
            {unitSelected?.assignment?.grade}
          </p>
          {unitSelected?.assignment?.comment ? (
            <p>
              Comments:{' '}
              <span className="whiteSpacePre">
                {unitSelected?.assignment?.comment}
              </span>
            </p>
          ) : null}

          {unitSelected?.assignment?.attachment?.length ? (
            <div className="overflow-hidden">
              <p className="mb-0-important pb-05">Instructor's marked sheet:</p>
              {unitSelected?.assignment?.attachment?.map((item, index) => (
                <p
                  className="flex-wrap cursor-pointer mb-0-important"
                  key={index}
                  onClick={() => downloadFile(item?.path, item?.originalname)}
                >
                  {index + 1}.
                  <span className="text-underline pl-1 text-italic text-primary">
                    {item?.originalname}
                  </span>
                </p>
              ))}
            </div>
          ) : null}
          <hr />
        </div>
      </div>
    </div>
  );
};

export default Failed;
